import { connect } from 'react-redux';

import { Row } from 'UIPackage/FormModule/components/Row';
import { IDecisionActForm } from 'DecisionPackage/MainModule/interfaces/IDecisionActForm';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { DatePickerField } from 'UIPackage/MainModule/components/DatePickerField';
import { TextInputField } from 'UIPackage/MainModule/components/TextInputField';
import { IDecisionFormRef } from 'DecisionPackage/MainModule/interfaces/IDecisionFormRef';
import { DecisionViolations } from 'DecisionPackage/DecisionFoundViolationsModule/components/DecisionViolations';
import { IBooleanSelectOption } from 'KnmPackage/MainModule/interfaces/IBooleanSelectOption';
import { IDictionaryKnoOrganizationSelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionaryKnoOrganizationSelectOption';
import { IDictionarySupervisionTypeSelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionarySupervisionTypeSelectOption';
import { IDecisionFormReason } from 'DecisionPackage/MainModule/interfaces/IDecisionFormReason';

import { DecisionActDocument } from './DecisionActDocument';
import styles from './DecisionActItem.module.scss';
import { IKnmErknmFormObject } from '../../KnmErknmPackage/MainModule/interfaces/IKnmErknmFormObject';

interface IDecisionActItemProps {
  watchOnly: boolean;
  isViolationFieldsWatchOnly: boolean;
  act: IDecisionActForm;
  formRef: IDecisionFormRef | undefined;
  name: string;
  isRequirements: IBooleanSelectOption | undefined;
  knoOrganization: IDictionaryKnoOrganizationSelectOption | undefined;
  supervisionType: IDictionarySupervisionTypeSelectOption | undefined;
  objects?: IKnmErknmFormObject[];
  created: string | undefined;
  reasons: IDecisionFormReason[] | undefined;
}

interface IDecisionActItemStoreProps {}

function DecisionActItemWithoutStore({
  watchOnly,
  isViolationFieldsWatchOnly,
  act,
  formRef,
  name,
  isRequirements,
  knoOrganization,
  supervisionType,
  objects,
  created,
  reasons,
}: IDecisionActItemProps & IDecisionActItemStoreProps) {
  return (
    <>
      <DecisionActDocument
        formRef={formRef}
        watchOnly={!!watchOnly}
        name={`${name}.document.attachments`}
        attachmentsNumber={act.document?.attachments?.length || 0}
      />
      <Row>
        <FieldBlock label={'Номер акта КНМ, СР'} color="black" placementLabel="left">
          <TextInputField name={`${name}.numberAct`} disabled={watchOnly} className="shared-row-field" />
        </FieldBlock>
      </Row>
      <Row>
        <FieldBlock
          label={'Дата и время составления акта КНМ, СР'}
          color="black"
          placementLabel="left"
          type="not-space"
        >
          <DatePickerField
            className={styles.DatePickerField}
            name={`${name}.creationActDateTime`}
            disabled={watchOnly}
            timeFormat
          />
        </FieldBlock>
      </Row>
      <div className={styles.DecisionViolationsWrapper}>
        <DecisionViolations
          watchOnly={watchOnly}
          isViolationFieldsWatchOnly={isViolationFieldsWatchOnly}
          isRequirements={isRequirements}
          knoOrganization={knoOrganization}
          supervisionType={supervisionType}
          objects={objects}
          reasons={reasons}
          created={created}
        />
      </div>
    </>
  );
}

const mapStateToProps = (): IDecisionActItemStoreProps => {
  return {};
};

export const DecisionActItem = connect(mapStateToProps)(DecisionActItemWithoutStore);
